import * as React from "react";
import {
    FaBolt, FaBuilding, FaBullseye, FaCamera, FaCheckCircle, FaComments, FaExclamationTriangle,
    FaFacebookF, FaGem, FaGlobe, FaHandPointer, FaHandshake, FaHeart, FaHistory, FaHome, FaInstagram,
    FaLightbulb, FaLock, FaMapMarkedAlt, FaMapMarkerAlt, FaMobileAlt, FaMousePointer, FaPalette, FaPhone,
    FaQrcode, FaRegHeart, FaRuler, FaSearch, FaStickyNote, FaStoreAlt, FaTheaterMasks,
    FaTimesCircle, FaTwitter, FaStar,
} from "react-icons/fa";
import type { IconType } from "react-icons";

const icons = {
    bolt: FaBolt,
    building: FaBuilding,
    bullseye: FaBullseye,
    camera: FaCamera,
    check: FaCheckCircle,
    comments: FaComments,
    error: FaExclamationTriangle,
    facebook: FaFacebookF,
    gem: FaGem,
    globe: FaGlobe,
    hand: FaHandPointer,
    handshake: FaHandshake,
    heart: FaHeart,
    heartOutline: FaRegHeart,
    history: FaHistory,
    home: FaHome,
    instagram: FaInstagram,
    lightbulb: FaLightbulb,
    lock: FaLock,
    map: FaMapMarkedAlt,
    marker: FaMapMarkerAlt,
    mobile: FaMobileAlt,
    mouse: FaMousePointer,
    palette: FaPalette,
    phone: FaPhone,
    qr: FaQrcode,
    ruler: FaRuler,
    search: FaSearch,
    sparkle: FaStar,
    store: FaStoreAlt,
    theater: FaTheaterMasks,
    times: FaTimesCircle,
    twitter: FaTwitter,
    note: FaStickyNote,
} satisfies Record<string, IconType>;

export type AppIconKind = keyof typeof icons;

const AppIcon = ({ kind, className = "" }: { kind: AppIconKind; className?: string }) => {
    const Icon = icons[kind];
    return <Icon aria-hidden="true" className={`inline-block align-[-0.1em] ${className}`} />;
};

export default AppIcon;
